module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h2', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "chap2",
      "src": "images/chap2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THIS CHAPTER OUR GOAL")])]), _vm._v(" is to help clinicians ask relevant questions to get an accurate account of their clients’ religious beliefs and values, gender-identity development, and any conflict clients may experience between their religious and gender identities. We will distinguish between assessment of children and assessment of adolescents/adults since this is a common distinction in the literature.")]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CULTURAL HUMILITY & ASSESSMENT")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As Hopwood and Witten (2017) remind mental health professionals, it is important that we clinicians become aware of our own beliefs and values and potential biases so that we are able to assess culture, beliefs, and values and incorporate multiple aspects of diversity, including religious and spiritual issues, in therapy in a respectful and competent manner. Our ethical obligation is to work actively to eliminate or significantly reduce the effects that biases can have on our work and to foster deep respect for the cultural and individual variables at play. In fact, practice guidelines explicitly discuss the influence of religion and spirituality on the decisions people make regarding gender identity, as well as access to resources, level of stress, resilience, and coping. This too offers a clear emphasis on taking seriously the intersection of cultural identities and exploring the “salience of these aspects of identity” in an ongoing way (American Psychological Association [APA], 2015, guideline 3).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Keep in mind that it is beyond the competencies of mental health professionals to adjudicate theological positions of major world religions or to prescribe a fixed way of integrating these positions into personal beliefs and values. Respect for the rights of individuals to self-determination is central to the mental health field. However, clinicians can speak to the mental health "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak",
      "title": "10"
    }
  }, [_vm._v("correlates of lives informed by or shaped by various teachings, as well as to some of the challenges in navigating gender identity and religious faith. Indeed, it is important to identify our own biases about religion as they arise. Clinicians will benefit from acknowledging that we cannot fully understand any individual’s particular experience. Thus, clinicians do well to invite clients to correct us insofar as we misunderstand, misrepresent, or devalue their religious/spiritual beliefs and other aspects of culture for them or those of their family. This is an important starting point as we enter into assessment of religious identity, gender identity, and exploration of the intersection of these and other aspects of identity in those we meet with.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In our clinical work, we have found that many clients are wary of mental health professionals for fear of their beliefs and values or their own experiences of gender identity being villainized, pathologized, or otherwise disregarded. Rapport building is best accomplished when these tensions and concerns are addressed overtly as part of the assessment process; this goes far in highlighting the dedication to ethical care for those we serve. Honest rapport and mutual understanding in the assessment process is most likely in the context of building trust and a nonjudgmental openness to the particular and nuanced experiences of individual clients and families.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There are important nuances to consider when it comes to working with gender minorities across different racial and ethnic groups. The Williams Institute at UCLA reported that 0.6% of the adult population identify as transgender. They estimate that 0.8% are African American or Black, 0.8% are Latina/o or Hispanic, 0.5% are White, and 0.6% are of another race or ethnicity. Additionally, in the U.S. Transgender Survey, 62% of participants identified as White, 17% as Latina/o, 13% as Black, 5% as Asian, 3% as multiracial, less than 0.1% as Native American, and less than 0.1% as Middle Eastern (Flores et al., 2016, p. 7)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Of note, people of color “experience deeper and broader patterns of discrimination than white respondents and the U.S. population” as a whole, including increased likelihood of living in poverty, being unemployed, and living with HIV (James et al., 2016, p. 6). This further highlights the diversity among transgender people and the importance of attending to the intersection of various aspects of identity as they relate to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak",
      "title": "11"
    }
  }, [_vm._v("quality of life, risk factors and strengths, goals for therapy, and so on. Exploration of ethnic identity as well as its interaction with religious identity can also help us unearth both challenges and resilience factors for different individuals who come to therapy around gender identity, and we would be remiss if we didn’t highlight this early on in the explanation of our approach.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("ASSESSMENT OF RELIGIOUS IDENTITY")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Most of the individuals and families who seek counseling from us at the intersection of gender identity and religious identity consider themselves highly religious. Understanding the precise nature of these religious beliefs and values is crucial to evaluating the conflict people may experience with their gender identity (or that of a loved one). Clinicians must assess religious identity, then, because a person’s religious and spiritual beliefs will shape their response to their own gender experience or that of a loved one.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Psychologists have developed measures for many aspects of religion and spirituality in a person’s life. Clinicians can consider measures of (a) religiosity/spirituality (e.g., spiritual well-being scale), (b) functioning and faith (e.g., religious problem-solving styles), (c) God concept or one’s emotional experience of God, (d) religious orientation (e.g., extrinsic religiosity), and (e) measures of one’s personal experience of God (Hall et al., 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Any number of these measures could be used to aid in the assessment of religious identity in a person’s upbringing and family. The spiritual genogram, for instance, has been used by many therapists to obtain information about a family’s religious and spiritual beliefs, values, and heritage (Hodge, 2001). Our focus should be on reaching a better understanding of the client’s or the family’s religious faith tradition, especially in relation to sex and gender norms, gender identity, and gender expression. We have found that even in cases where a young person navigating gender identity does not subscribe to their family’s spiritual beliefs, that person’s gender identity exploration could be impacted by messaging they received about gender while they were growing up.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Assessment of children.")])]), _vm._v(" When we provide a consultation to a family with a young child, we assess the family’s religious and spiritual background, as well as the extent to which their religious beliefs and values inform their response to their child’s gender expression today.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak",
      "title": "12"
    }
  }, [_vm._v("When we meet with parents, we ask them whether religious or spiritual faith is a part of their current way of being in the world. As we noted above, a family’s religious and spiritual identity is often why they are coming to see us rather than going to another specialty clinic, even when we have offered a referral to a larger, more comprehensive specialty clinic.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Because religion is often salient in the lives of the families we work with, we ask parents about the religious faith traditions they were raised in (broadly), as well as the local religious faith communities they have participated in (narrowly). We ask them how much of the faith they were raised in is a part of their life today, or how much it has informed the raising of their children, regardless of their current practices, using inquiries like the following:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Tell me about your religious faith tradition growing up.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How were your religious beliefs and values expressed in your home growing up?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How much of the religious faith tradition you were raised in is a part of how you view things today?")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We then move our assessment toward the questions these parents are raising about a loved one’s gender identity. We ask how the faith they adhere to today addresses questions that arise around sex and gender.")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("As you think about your religious faith tradition now, what have you found it teaches on sex and gender?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How do teachings from your religious faith community inform your understanding of sex and gender?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How do teachings from your religious faith community shape your response to your child?")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Assessment of adolescents/adults.")])]), _vm._v(" When we provide a consultation to a family with an adolescent—that is, any person between the ages of ten and nineteen—we assess the family’s religious and spiritual background in much the same way we assess a family’s background when they present to us with a young child.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When we assess an adolescent, however, we also ask the adolescent about the religious tradition they are being raised in (broadly) and their experience in their local community of faith (narrowly). That is, we want to have a better "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak",
      "title": "13"
    }
  }, [_vm._v("understanding of their experience in the Southern Baptist denomination, for instance, as well as what it has been like for them to be a part of Redeemer Church, for example.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As we do when we interview parents, we want to ask the adolescent how much of the faith tradition they were raised in informs their beliefs today. If they distance themselves from the family faith tradition or reject it outright, it may be helpful to understand what led them to that decision and whether that decision was related in any way to the tradition’s teachings on sex and gender.")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Can you share a little about your religious faith community growing up?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How much of the faith tradition you were raised in is a part of how you view things today?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Can you share a little about what your religious faith community teaches about sex and gender?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How have those teachings about sex and gender been communicated to you—either at your place of worship or at home?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Which aspects of the teachings about sex and gender from your faith tradition are important to you today?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("ASSESSMENT OF GENDER IDENTITY")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("Assessment of children.")])]), _vm._v(" The field is not in agreement about the best way to evaluate children’s gender identity, and we see a range of models being used at different specialty clinics. Berg and Edwards-Leeper (2018) provide a helpful overview of some of these different approaches. They highlight the general shift in the mainstream of the field away from assessment questions and measures that assume a pathology model and toward approaches that frame gender identities in terms of diversity. These now-prevailing approaches distinguish common gender exploration and gender-diverse experiences from gender dysphoria as it is currently understood in contemporary nosology.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Broadly speaking, this shift in the field is a move toward what is sometimes referred to as “gender affirmative assessment” (Berg & Edwards-Leeper, 2018, p. 103). Like previous assessment models, gender-affirmative assessment can include interviews with parents and the child, play therapy with the child, and psychological batteries that measure cognitive functioning or are "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak",
      "title": "14"
    }
  }, [_vm._v("otherwise intended to rule out possible co-occurring mental health or behavioral issues. Regardless of which methods are used, gender-affirmative assessments seek to move away from traditional, normative assumptions about gender development and toward more open, child-centered approaches that reflect an expanded vista for gender, gender expressiveness, and diverse gender identities.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When families approach us for a consultation, we inform them of other more comprehensive specialty clinics that are multidisciplinary and might offer a range of approaches to gender-identity assessment. However, many of our referrals desire to navigate gender-identity questions as individuals or families in ways that are sensitive to their religious beliefs. They have sometimes chosen to come to our clinic after seeking services elsewhere and finding the assessment process to be hasty, feeling that their beliefs have been dismissed or undermined. A failure to assess religiosity, and how religion and spirituality interact with beliefs about gender, highlights again the importance of cultural humility; clinicians must attend to religion and spirituality as important diversity variables among those we work with.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We describe our approach to gender-identity assessment as "), _c('i', [_vm._v("balanced")]), _vm._v(", "), _c('i', [_vm._v("client-centered")]), _vm._v(", and"), _c('i', [_vm._v(" without a fixed outcome")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" It is balanced because we locate ourselves between two more extreme positions: (a) those who are critical or dismissive of transgender and gender-diverse experiences and (b) those who, in an effort to be affirming of transgender and gender-diverse experiences, may do so without sufficient regard for contextual and other issues. We aspire to thoughtfully engage with the identified client and their family, recognizing that there are different lenses through which people see gender identity: integrity, disability, and diversity. As we prepare for consultations, we try to locate different family members in terms of these lenses and begin to consider how these lenses shape expectations surrounding gender identity, gender role, and so on. We try to be mindful of how current cultural trends are understood by different stakeholders, including family members, their religious communities, and their other networks of social support and influence.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak",
      "title": "15"
    }
  }, [_vm._v("We are also client-centered. We try to listen to our clients as they sort out their experiences of gender, both past and present; as they negotiate their beliefs about sex and gender; and as they determine how to move forward in their unique family and cultural context, taking into account their religious faith identity and how their faith informs their decision making.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We do not enter into therapy or into a consultation with a fixed outcome in mind. Our concern is not to push a priori conclusions about the best outcome of a client’s gender-identity exploration, in keeping with the approach of others in our field (e.g., Sloan & Berke, 2018; Substance Abuse and Mental Health Services Administration [SAMHSA], 2015). We want to be open-ended, providing services without trying to force the experiences of our clients and families into a single mold. What our clients determine is best for them may range considerably from client to client as we consider a wide range of concerns.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One of the most important considerations we have found in assessment and subsequent care of a child is that parents focus on their unconditional love for their child as a starting point for their interactions around gender identity. When parents enter into the assessment process with assumptions about a normative or particular fixed outcome for their child, our experience has been that these assumptions can be experienced by their child as conditional acceptance. This is a tension we try to address early on. We do not know how a specific child will express their gender identity, how that expression will either stabilize or fluctuate over time, and what a child’s gender identity will ultimately be; however, we do know that a child is best served by parents who express unconditional love and regard for their child.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We tend to rely heavily on parents in the assessment of children. However, it is important to make clinical observations of the child in addition to gathering parental reports. The goal of these observations is to gain a sense of how an outsider might perceive the child based on general impressions. You might think through such areas of gender presentation as clothing, hairstyle, and accessories (e.g., makeup, jewelry, purse, etc.), as well as voice inflection, gestures, and mannerisms. You can also ask yourself, How would someone who did not know this child perceive this child in terms of the child’s gender and why? We typically also note the affect expressed by the child and any concerns they have about the consultation or counseling.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak",
      "title": "16"
    }
  }, [_vm._v("To supplement clinical observation of a child, we have found it helpful to obtain information from parents about what they see at home. This information can be collected over two to three weeks and involves a simple observational record of what parents see. We provide parents with a structure for identifying the kinds of behaviors and experiences that can help us determine whether a diagnosis of Gender Dysphoria is warranted (see worksheet 2.1). For example, we ask parents to make note of their child’s gender-atypical play and activities, gender-related statements about themselves or themselves in comparison to others, preferences for clothing, and so on.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In one case, when preparing for a consultation with parents of a five-year-old child, we asked the parents to complete a daily parent observation form for a two-week period in advance of the consultation. The parents observed the child frequently pulling up his shirt in order to show his belly; selecting morning cartoons and stating, “I only want to watch girl shows”; asking to wear his mother’s sweater; and going into his mother’s closet and coming out with her heels on.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We also invite parents to share how they respond to gender-atypical behaviors in the moment so that we get a better sense for their concerns and their instincts as parents. These exchanges are significant to the counseling process because they can either contribute to a child’s shame or convey a message of love. We have found that when parents experience significant anxiety in this area, they sometimes turn to fear-based parenting techniques they may later regret. A parent might respond to a boy wearing his mother’s high-heeled shoes by sharply scolding him out of anger, for instance; it would be helpful for us to know about this pattern so that we can offer alternative responses.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Parents will often offer differing—and perhaps contradictory—records of what is occurring at home. For this reason, it may be helpful to have parents keep separate records. Clinicians should also get a sense for each parent’s level of daily involvement with the child since factors such as a desire to please a same-sex parent or to hide gender-atypical play may influence parents’ observations.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It may be helpful, too, to obtain information from a teacher about a child’s behavior at school. This avenue of assessment must be weighed against whether the child’s gender-identity exploration is something the family wishes for the school to be made aware of. Parents differ in their degree of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak",
      "title": "17"
    }
  }, [_vm._v("comfort involving the school system at this stage of assessment—and as you can imagine, parents also disagree with one another about this from time to time. Some parents express concern that initiating this discussion with school personnel could be stigmatizing for their child, heighten the child’s anxiety in social settings, or prematurely reveal something the child is still working to make sense of. In any case, if parents elect to ask a teacher to complete an observational form, this form covers similar kinds of experiences and observations: the child’s gender-atypical play and activities, gender-related statements about themselves or themselves in comparison to others, preferences for clothing, and so on (see worksheet 2.2).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Interviews")]), _vm._v(".")]), _vm._v(" Children are diagnosed with Gender Dysphoria only if six of the eight criteria listed below are met; the first criterion must be one of the six criteria that is met. These criteria must have been met for a minimum of six months. Children diagnosed with dysphoria also experience corresponding distress or impairment in social or educational functioning related to their gender identity.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The eight criteria are:")]), _vm._v(" "), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong desire to be of the other gender or an insistence that one is the other gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong preference for wearing clothes typical of the opposite gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong preference for cross-gender roles in make-believe play or fantasy play")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong preference for the toys, games, or activities stereotypically used or engaged in by the other gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong preference for playmates of the other gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong rejection of toys, games, and activities typical of one’s assigned gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong dislike of one’s sexual anatomy")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong desire for the physical sex characteristics that match one’s experienced gender (APA, 2013, p. 452)")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Clinicians can proceed by asking about each of the eight criteria directly. For example, they can ask, When you consider the past six months, would "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak",
      "title": "18"
    }
  }, [_vm._v("you say that your loved one has a strong desire to be the other gender or insists that they are the other gender? However, we have found it much more helpful to interview around the topics in a more open-ended manner by asking parents to describe their child’s clothing preferences, roles in play, preferences for toys, preferences for playmates, and so on. Here’s what we mean:")])]), _vm._v(" "), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" When you consider the past six months, how would you describe the way your loved one has talked about or experienced their gender? [Probe for the parents’ first awareness of their child’s account of their gender, how the gender identity has been expressed over time, whether it fluctuates or is rather stable, and so on.]")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" When you consider the past six months, how would you describe your loved one’s clothing preferences? [Probe for how much choice their child has in clothing selection, what kinds of clothing they would wear if it were entirely up to them, and so on.]")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" When you consider the past six months, how would you describe your loved one’s make-believe play or fantasy play? [Probe for gender roles taken, whether these roles are assigned by an older sibling or peer, what roles the child prefers, and so on.]")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" When you consider the past six months, how would you describe your loved one’s preferences for toys and games—what do they enjoy playing? What kinds of toys and games do they gravitate toward? What kinds of activities does your loved one enjoy? [Probe for the child’s top two to three toys, top two to three games, and top two to three activities.]")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" When you consider the past six months, how would you describe your loved one’s interest in toys, games, or activities that children of the same sex typically gravitate toward? [Probe by naming a few toys, games, and activities commonly associated with the same sex and listen for how the parents describe their child’s response to those toys, games, and activities. Disinterest is not the same as strong rejection, but listen for how they describe their loved one’s response to and experience with those toys, games, and activities.]")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak",
      "title": "19"
    }
  }, [_vm._v("When you consider the past six months, who does your loved one most enjoy playing with—I’m thinking here in terms of their playmates? [Probe for preferences when they have options, and be sensitive to playmate availability in terms of who is in the home and neighborhood.]")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" When you consider the past six months, how would you say your loved one has responded to their own sexual anatomy? [Probe for any comments or questions about their sexual anatomy, a sense of identification with either parent by referencing sexual anatomy, and so on.]")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" When you consider the past six months, how has your loved one talked about or expressed interest in the physical sex characteristics of the other gender? [Probe for any comments or questions about physical sex characteristics, a sense of identification with either parent by referencing physical sex characteristics, and so on.]")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We listen for whether the criteria of Gender Dysphoria are met as we go through our interview with parents. In order to help parents accurately gauge a six-month period during which symptoms could have presented, we might ask parents to think of an event that occurred at least six months ago, perhaps a birthday, a holiday, or some event that occurred in the news cycle. When they have chosen an event, we ask them to use that event to anchor their timeline so we get a more accurate picture of what the past six months have been like for their child. Answering questions regarding gender identity can be emotional for parents, making objectivity much more difficult at times.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In addition to conducting this kind of parental interview, clinicians can also utilize gender-identity-related parent measures. However, some of these measures have been normed on the previous "), _c('i', [_vm._v("DSM")]), _vm._v(" diagnosis (American Psychiatric Association, 2013) of gender-identity disorder (and may be in the process of being updated), and many have been evaluated as otherwise inadequate for a variety of reasons. We do utilize some parent measures with the understanding that there are inherent limitations to any measure today and that new measures are undoubtedly being developed for future assessment. Still, it is important to remain aware whenever possible of the latest and most widely accepted measures being used rather than relying on outdated measures.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Assessment of children with possible Gender Dysphoria should not rely on parent interviews and gender-identity-related parent measures alone. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak",
      "title": "20"
    }
  }, [_vm._v("Assessment can also entail the use of instruments for young children (under the age of six), instruments for children under the age of twelve, and additional instruments for parents and teachers (see Berg & Edwards-Leeper, 2018, p. 104). In some models of assessment, psychological testing protocols are recommended, and these include a measure of IQ, attachment, and personality, along with specific measures of gender identity (Berg & Edwards-Leeper, 2018, p. 105).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As we noted above, the field is not always in agreement about the best way to evaluate children, and there is a range of models being used at different specialty clinics. Some clinics do not offer comprehensive psychological testing, some perform initial screening and may recommend additional psychological testing, and still others focus primarily (and in some cases exclusively) on gender identity as such. In other words, some professionals today view these additional assessment instruments as unnecessary at the outset; that is, a clinician can do some basic interviewing or use standard semistructured interviews to determine if further evaluation of, say, cognitive development is warranted without feeling like such testing is necessary at the outset (Berg & Edwards-Leeper, 2018, pp. 105-6).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We also use the metaphor of a book with many chapters (see worksheet 2.3)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Parents can reflect on an older child’s life and identify two or three chapters (or more) that they can title, and then they can identify key characters, themes, and so on, specifically associated with gender identity. We also invite parents to provide this information when we meet with adolescents.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Before we close this section on assessment of children, we should note that one of the more frequently cited concerns in the assessment of children is the potential for co-occurring autism spectrum disorder (ASD). Children who have ASD are diagnosed with Gender Dysphoria at a higher rate than children who do not meet criteria for ASD, and more information about the relationship between Gender Dysphoria and ASD is not well understood at this time. The current recommendations are for children to be assessed by a specialist in gender identity and a specialist in ASD (unless a specialist in both gender identity and ASD is available), and for the two specialists to work together on providing care to the child and family. In addition, it can be helpful "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak",
      "title": "21"
    }
  }, [_vm._v("to utilize either ASD screeners or something like the Social Communication Questionnaire as a way of further assessing a child’s social functioning and how this may or may not factor into Gender Dysphoria (Leef et al., 2019).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Assessment of adolescents/adults.")])]), _vm._v(" As with our assessment of children, our approach to assessment of adolescents and adults is also to offer a "), _c('i', [_vm._v("balanced, client-centered ")]), _vm._v("gender-identity assessment"), _c('i', [_vm._v(" without a fixed outcome")]), _vm._v(". We obtain basic, preliminary information (see worksheets 2.4 and 2.5). We do not want to begin with an agenda in either direction with our clients. We try to remain balanced around a range of considerations that an adolescent or adult is weighing as they explore gender identity and any conflicts they may report between their gender identity and religious faith. We remain client affirmative and consider a range of options without a fixed outcome for gender identity.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The diagnosis of Gender Dysphoria is made with adolescents and adults only if two of the six criteria listed below are met. As with Gender Dysphoria in childhood, these criteria must have been met for a minimum of six months. There must also be corresponding distress or impairment in social or educational functioning. The six criteria are:")]), _vm._v(" "), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A marked incongruence between one’s experienced/expressed gender and primary and/or secondary sex characteristics")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong desire to be rid of one’s primary and/or secondary sex characteristics")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong desire for the primary and/or secondary sex characteristics of the other gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong desire to be of the other gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong desire to be treated as the other gender")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" A strong conviction that one has the typical feelings and reactions of the other gender (APA, 2013, p. 452)")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The benefit to interviewing adolescent and adult clients is that you can now hear from them directly about their experiences rather than interviewing only parents and relying heavily on their observations about their child. When it is feasible to do so, we prefer to interview one or both parents as well as an adolescent client.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "role": "doc-pagebreak",
      "title": "22"
    }
  }, [_vm._v("As in the case of parental interviews about their children, interviews conducted with adult or adolescent clients could include questions directly drawn from the criteria of Gender Dysphoria. For example, a clinician could ask directly: “In the past six months, have you experienced a marked incongruence between your experienced/expressed gender and primary and/or secondary sex characteristics?” (APA, 2013, p. 452). This would be the wording of the diagnostic manual, but it is not particularly accessible to most families we meet, and some adaptation would be helpful. Also, when we do ask direct questions, we again ask the adolescent or adult to think of an event or holiday that occurred at least six months ago. That event becomes an anchor in the timeline so we get a more accurate understanding of how the last six months have been for the adolescent or adult.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But rather than ask these direct questions, we tend to ask broader questions about gender identity. We have found it helpful to frame a client’s experience of their gender identity as a book with many chapters. We then invite the teen or adult to title each chapter and share some of the key people in that chapter of their lives, the primary themes of that chapter, and so on. This approach helps us identify when the client’s gender-identity experiences first came about (onset) and how their experience of gender identity has progressed over time (course), including how stable their gender identity has been and whether it has fluctuated.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For example, in our work with Layla, a twenty-one-year-old natal male who presented with a cross-gender identity, it was clear that Layla’s gender identity had only been cross-gender for about three months. Layla reported that prior to that time her original experience of gender identity had been gender nonbinary (since shortly after puberty, around age thirteen). She denied any gender-atypical behavior or self-identification throughout childhood. In many ways this presentation would be considered an atypical case of Gender Dysphoria (late-onset). With such recent shifts in gender identity, it seemed more time would help everyone determine how stable Layla’s cross-gender identity would be and what steps might be taken based on gender-identity stability or ongoing fluctuations.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When we work with adolescents, we have found it helpful to ask both parents and the adolescent to provide a narrative account of the adolescent’s life; we then probe for the kinds of material that would help us determine if the criteria of Gender Dysphoria are met. We do the same when we assess adults.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "role": "doc-pagebreak",
      "title": "23"
    }
  }, [_vm._v("As we discussed with the assessment of children, this narrative exercise can be done effectively using the metaphor of a book with many chapters (see worksheet 2.6). Clients might think of early childhood or childhood, from birth until age twelve, as the first chapter of their book. They might think of the next chapter as the beginning of adolescence. Some people divide their story into chapters that include elementary school, middle school, and high school.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Adults typically add a chapter on their early twenties or college age or age of vocational training. They might add a chapter or more beyond that as well, depending on their current age and other life experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We also ask our clients to identify the chapter that led them to come into our clinic to speak to someone about their gender identity. This might be a different chapter from the chapter they hope to write during their time in counseling, which might be different still from the chapter they hope to write in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For example, Finley, a fifteen-year-old natal female who identified as male, shared how the decision to come in for counseling felt like it was made by his parents. Although Finley assented to counseling, the chapter title he came up with for his current season was “What They Want.” When we discussed with Finley what this title meant to him, he shared that he wrote it down as a reflection of what he felt his parents wanted for him—that is, to meet with a counselor to discuss his gender identity. We were careful to ask him what he wanted and whether counseling could be a part of that, especially if counseling could focus on specific goals he identified for himself or could improve his relationship with his parents.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Listening to and unpacking what chapter titles mean can help establish and strengthen the therapeutic alliance. It can also lead to discussions of goals for counseling that can be empowering for a client, because they might for the first time be asked what they want out of their time with a counselor. These discussions can lead to a new chapter, a chapter for counseling itself. The chapter might be titled “Clarity” or “New Direction” or “My Time”—some indication of the client’s hopes and expectations for their time in counseling.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another chapter you may want to discuss with clients is the next chapter they hope will be written once counseling has come to an end. Clients might speculate early in their counseling about what that chapter will be, but this is a topic worth returning to; clients often develop new ideas of what their "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "role": "doc-pagebreak",
      "title": "24"
    }
  }, [_vm._v("next chapters might be titled on the other side of counseling, ideas that differ significantly from the next chapters they title as counseling is just getting underway. It is also possible to title a chapter/appendix related to questions or thoughts to explore in the future. This helps clients acknowledge that they will continue to sort out aspects of their experience and future steps even as therapy ends.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Outlining life by way of chapters can also help clinicians appreciate the range of messages a client may have received from key figures in their life—including parents, peers, youth ministers, pastors, mentors, siblings, and media—regarding gender identity and people who experience gender dysphoria. These insights are critical in identifying aspects of experience that may underlie the ebb and flow of overt gender-related distress.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For instance, Kit, a fourteen-year-old natal female who presented as androgynous, used she/her/hers pronouns for herself but also struggled with these pronouns. She reported a long history of gender-related distress and had not yet come to a coherent sense of gender identity when she came to see us with her parents. As early as age four, she would choose to play male roles in games; secretly dress in her older brother’s clothing, including undergarments; beg her parents to let her cut her hair; and refuse to wear stereotypically feminine attire. Her parents, however, did not remember Kit’s gender-related distress being as persistent as Kit described it. They recalled that, around middle school, she began to present as stereotypically feminine in dress and interests; she “was obsessed with makeup,” and “her favorite color was pink.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When exploring the chapters of her life, Kit came to realize that she had heard messaging around this time from teachers and a pastor that “you need to stop acting like a boy,” and her peers had been bullying her because of her presentation at school. Kit recalled her prayer life involving “asking God to take this pain away.” She assumed that “if I act more like a girl, maybe I’ll feel more like one too.” Kit had never told her parents about these experiences until our consultation, which helped them appreciate the way her gender atypicality had fluctuated, even while her distress around gender had not shifted in the way her parents thought at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Charting the timeline of a person’s gender-identity journey can also help us identify the onset and course of any co-occurring concerns, including "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "role": "doc-pagebreak",
      "title": "25"
    }
  }, [_vm._v("mood symptoms such as depression and anxiety, that may complicate gender-identity exploration or increase risk of self-harm. Some clients wonder if pursuing treatment for gender dysphoria will automatically alleviate co-occurring concerns. Clarifying the onset and course of these co-occurring concerns can clarify the degree to which these concerns coexist with or emerge from gender-related distress. Teasing these things apart—differentiating between dysphoria and depression, for instance—can help individuals and their families make informed decisions about courses of treatment, prioritize aspects of care, and set more realistic expectations for the alleviation of symptoms.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Exploring the onset, course, and timeline of gender-atypical behavior can also help clinicians distinguish early-onset dysphoria from late-onset dysphoria, as well as ruling out other possible diagnoses that must be considered before landing on a diagnosis of Gender Dysphoria. Some experiences that look at first like gender dysphoria may be motivated by another rationale. For example, a person might engage in gender-bending activities independent of their gender identity as a way to push back against cultural norms for sex and gender. We think of Jax, a fourteen-year-old natal male who identified as gay. He wore nail polish, shaved his legs, and dressed in female clothing periodically, which he reported was out of boredom. For him, these behaviors were not an expression of gender identity or a means of coping with dysphoria. He saw them as ways to challenge his parents’ assertion of rigid gender stereotypes.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Fetish behaviors likewise do not in and of themselves reflect gender dysphoria, although gender dysphoria may develop later in concert with these behaviors. Consider the example of James, a natal male college student who sought treatment for what he described as “a strange addiction.” Since the age of seven, James would periodically sneak into his sister’s closet to wear her clothing and undergarments. At first, he simply felt curiosity; it was not until his mother found him dressed this way one afternoon that he felt immense shame about his experience. She never brought it up again, but he recalled in our work together that “her reaction said it all.” “Good little boys never do stuff like that,” she had said. So his shame began. He continued to engage in this behavior, taking care to keep it hidden.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When he hit puberty, James found himself aroused by this behavior, and it became even more laden with secrecy. James’s faith was important to him, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "role": "doc-pagebreak",
      "title": "26"
    }
  }, [_vm._v("but as he grew older and began to feel more “disgusted” with his behavior, he came to believe that “God doesn’t want to hear from me until I get this under control.” In college, he learned from the media and peers about the reality of gender dysphoria. He resonated with these narratives, beginning for the first time to wish he was a female and feeling great conflict about the fact that he was not. In this case, James’s gender dysphoria emerged from a fetish behavior; thus, our therapy with James dealt with both gender identity and with the original fetish.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some teenagers seeking a sense of identity or community may find these things within the transgender community or broader LGBTQ+ community; others may turn to the language and categories we refer to as emerging gender identities (see Yarhouse & Sadusky, 2020). However, those who align themselves with transgender or emerging gender identities for such reasons may not meet criteria for Gender Dysphoria. We want to help these individuals understand their experience of gender identity without assuming Gender Dysphoria in every case.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We also ask adolescents and adults to rate their experience of incongruence along a scale. It is important to remember that gender dysphoria can reside along a continuum of intensity and can ebb and flow in a person’s life. Dysphoria must be managed through day-to-day decisions, and some dysphoria can spike around particular events. The rating scale gives us a better sense for what clients are experiencing (see worksheet 2.7) and can lead to helpful discussions about their gender incongruence. We also ask them to rate their ability to cope with any dysphoria that may be associated with the incongruence. Coping strategies vary considerably and are often discovered through trial and error. This initial rating can lead to productive discussions about coping strategies throughout the course of therapy.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As with assessment of children, assessment of adolescents can vary considerably among specialty clinics. Some clinicians focus on comprehensive interviews of gender identity while others also include various gender-identity-related adolescent and parent measures. In some specialty-clinic models of assessment, psychological testing protocols are recommended: measures of IQ, attachment, and personality, along with specific measures of gender identity.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "role": "doc-pagebreak",
      "title": "27"
    }
  }, [_vm._v("As we noted in our section on assessment of children, we tend to conduct a comprehensive gender-identity interview with the adolescent and the parent(s) separately, followed by gender-identity-related adolescent and parent measures and additional screening tools (for example, screening for depression) if the intake suggests that a co-occurring concern is likely present. Some clinicians would use fewer or none of these measures; others would add a complete psychological battery.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As we observe changes in the field today, we believe these different approaches reflect different assumptions about what is most helpful to an adolescent and their parents. What these approaches all tend to have in common is a desire to be as affirmational as possible in response to an adolescent who is exploring a gender-diverse presentation.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We noted early on in this chapter that it is important for clinicians to become aware of our own values and potential biases regarding a client’s beliefs. It is also important for us to reflect on our beliefs and assumptions regarding gender, gender identity, gender expression, and gender roles. This self-reflection will help us assess gender-identity development and discuss a range of options with families of young children and adolescents, as well as discuss services with adults in a respectful and competent manner.")]), _vm._v(" "), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "role": "doc-pagebreak",
      "title": "28"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WORKSHEET 2.1. PARENT OBSERVATION FORM")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Day:")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-002"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "padding": "7px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "73.08%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("PLAY")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("DESCRIPTION:")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("MY RESPONSE:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("MANNERISMS/")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("VOICE INFLECTION")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("DESCRIPTION:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("MY RESPONSE:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("STATEMENTS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("DESCRIPTION:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("MY RESPONSE:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("My child’s overall emotional state today:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("My own overall emotional state today:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "role": "doc-pagebreak",
      "title": "29"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WORKSHEET 2.2. TEACHER OBSERVATION FORM")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Day:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-003"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "padding": "7px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "69.37%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("PLAY")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("DESCRIPTION:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("PEER RESPONSE:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("MANNERISMS/")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("VOICE INFLECTION")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("DESCRIPTION:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("PEER RESPONSE:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("STATEMENTS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("DESCRIPTION:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("PEER RESPONSE:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Child’s overall emotional state today:")]), _c('span', {
    staticClass: "tabulation"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Child’s overall relationships with peers today:")]), _c('span', {
    staticClass: "tabulation"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "role": "doc-pagebreak",
      "title": "30"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WORKSHEET 2.3. NARRATIVE INTERVIEW WITH PARENTS")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We tend to think of books as being divided into chapters. How many distinct chapters would you say you and your child have experienced together? For each chapter, please provide a title, the key theme associated with that chapter, and the key people. Write a brief account of what makes that time in your child’s life a distinct chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 1: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 2: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 3: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 4: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter to bridge to counseling: When you think about the chapter of your life that led to the decision to come to counseling, how would you title that chapter, that decision? Again, who are the key characters, and what are the key themes associated with that chapter?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "role": "doc-pagebreak",
      "title": "31"
    }
  }, [_c('b', [_vm._v("Present chapter (counseling): If your life were a book with many chapters (some having been written, some you are writing now, and others you will write in the years to come), how would you title the chapter you are writing today? Who are the key characters, and what are the key themes associated with this chapter?")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Future chapter: If your life were a book with many chapters (some having been written, some you are writing now, and others you will write in the years to come), how would you title the next chapter you hope to write? Who are the key characters, and what are the key themes associated with this chapter?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("What are the questions/thoughts that linger for you that you may want to delve into in the future? How will you continue to explore these thoughts/questions?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Note to clinician: In each chapter, in addition to title/theme/people, listen for how the parents describe what counts as masculine or feminine behavior in a child and how frequently those behaviors are present in their loved one.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "role": "doc-pagebreak",
      "title": "32"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WORKSHEET 2.4. ADOLESCENTS: PRELIMINARY INFORMATION")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Experienced gender (check one): ______boy ______girl ______transgender ______nonbinary ______prefer to self-describe: ")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Anatomical sex (check one): ___male ___female ___intersex")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Pronouns (check one): ___ he/him/his ___ she/her/hers ___ they/them/theirs ___ Other: ______")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I have dressed exclusively as a _______________________ for_________ (months/years)")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I have sometimes dressed as a ______________________ for_________ (months/years)")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("If you have made changes in dress related to gender identity, when did you first make these changes? ")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("How were you referred here? ")]), _c('span', {
    staticClass: "tabulation"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Have you been evaluated by another mental health professional or gender program?")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("______Yes       ______ No")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("If yes, please list the mental health professional or gender program, indicating the dates of treatment and the reason you discontinued: ")]), _c('span', {
    staticClass: "tabulation"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("PERSONAL HISTORY")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Please briefly describe what you think your concerns are:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("You are here for professional services. How will you measure whether the professional services were helpful to you?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("DESCRIPTION OF SELF")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("How do you describe yourself today?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-005"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "role": "doc-pagebreak",
      "title": "33"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WORKSHEET 2.5. ADULTS: PRELIMINARY INFORMATION")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Experienced gender (check one): ______man ______woman ______transgender ______nonbinary ______prefer to self-describe: ")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Anatomical sex (check one): ___male ___female ___intersex")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Pronouns (check one): ___ he/him/his ___ she/her/hers ___ they/them/theirs ___ Other: ______")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I have dressed exclusively as a _______________________ for_________ (months/years)")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I have sometimes dressed as a ______________________ for_________ (months/years")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("If you have made changes in dress related to gender identity, when did you first make these changes?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("How were you referred here?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Have you been evaluated by another mental health professional or gender program? ")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("______Yes ______ No")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("If yes, please list the mental health professional or gender program, indicating the dates of treatment and the reason you discontinued:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("PERSONAL HISTORY")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Please briefly describe what you think your concerns are:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("You are here for professional services. How will you measure whether the professional services were helpful to you?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("DESCRIPTION OF SELF")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("How do you describe yourself today?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-006"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "role": "doc-pagebreak",
      "title": "34"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WORKSHEET 2.6. NARRATIVE INTERVIEW WITH ADOLESCENT/ADULT")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We tend to think of books as being divided into chapters. How many distinct chapters would you say you have experienced with respect to your gender? For each chapter, please provide a title, the key theme associated with that chapter, and the key people. Write a brief account of what makes that time in your life a distinct chapter. Be sure to offer some description that covers elementary school years, middle school years, and high school years among the various chapters you choose to describe.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 1: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 2: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 3: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Chapter 4: ")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Additional chapters (as needed):")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "role": "doc-pagebreak",
      "title": "35"
    }
  }, [_c('b', [_vm._v("Chapter to bridge to counseling: When you think about the chapter of your life that led to the decision to come to counseling, how would you title that chapter, that decision? Again, who are the key characters, and what are the key themes associated with that chapter?")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Present chapter (counseling): If your life were a book with many chapters (some having been written, some you are writing now, and others you will write in the years to come), how would you title the chapter you are writing today? Who are the key characters, and what are the key themes associated with this chapter?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Future chapter: If your life were a book with many chapters (some having been written, some you are writing now, and others you will write in the years to come), how would you title the next chapter you hope to write? Who are the key characters, and what are the key themes associated with this chapter?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("What are the questions/thoughts that linger for you that you may want to delve into in the future? How will you continue to explore these thoughts/questions?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Note to clinician: In each chapter, in addition to title/theme/people, listen for how the client experiences their gender identity, whether it appears to be rather stable or somewhat variable, and so on.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-007"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "role": "doc-pagebreak",
      "title": "36"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("WORKSHEET 2.7. INCONGRUENCE AND COPING")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Directions: People experience different degrees of incongruence between their gender assumed at birth and their gender identity today. People also live with different tolerances for the incongruence they feel. Some people are able to live with a high level of internal gender dysphoria. Some people are "), _c('i', [_vm._v("not")]), _vm._v(" able to live with this high level of incongruence.")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('b', [_vm._v("1. Make a mark on the first line below (which shows a continuum from very low to very high) that shows your current experience of gender incongruence.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_gauche"
  }, [_c('b', [_vm._v("My experience of gender incongruence:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif retrait_gauche"
  }, [_c('b', [_vm._v("very low"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("low"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("moderate"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("high"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("very high")])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('b', [_vm._v("2. Then make a mark on the second line below that shows your current ability to cope with your experience of gender incongruence.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_gauche"
  }, [_c('b', [_vm._v("My current ability to cope with gender incongruence:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif retrait_gauche"
  }, [_c('b', [_vm._v("very low"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("low"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("moderate"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("high"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("very high")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("(Reproduced with permission from Yarhouse, 2015)")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Look at your marks on the two continuums above and reflect on these questions:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('b', [_vm._v("1. What does your rating of your sense of incongruence mean to you?")])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('b', [_vm._v("2. What does your rating of your ability to live with gender incongruence mean to you? What are some of your current coping strategies?")])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 78
// module chunks = 0